module.exports = __webpack_public_path__ + "media/images/bnr-insta-feed-sm-fda4742b9216c8d01ac4d0ef8c196a56.png";